import { render, staticRenderFns } from "./addRecoil.vue?vue&type=template&id=d346cd84&scoped=true"
import script from "./addRecoil.vue?vue&type=script&lang=js"
export * from "./addRecoil.vue?vue&type=script&lang=js"
import style0 from "./addRecoil.vue?vue&type=style&index=0&id=d346cd84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d346cd84",
  null
  
)

export default component.exports